export const TenancyValidationSchema = {
    reject_reason: [
        { rule: "required", message: "Reason required" },
    ]

}